import { useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";

interface ICompanyNameProps {
  licenseCount: number;
  isRenew: boolean;
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
}

// 통합 이용약관, 개인정보처리방침 동의
const LicenseCount = ({
  licenseCount,
  isRenew,
  handleChange,
}: ICompanyNameProps) => {
  const { isOciProduct } = useIsOciProduct();
  const { errors, touched, setFieldValue, values } = useFormikContext<any>();
  const { t } = useTranslation();
  return (
    <Form.Group className="mb-3">
      <Form.Label>{t("siteType.basic.detail.plan.userNum")}</Form.Label>
      <Form.Control
        type="number"
        name="licenseCount"
        value={licenseCount}
        onChange={handleChange}
        className="form-control custom-form width max-w-120"
        min={
          isOciProduct &&
          window.sessionStorage.getItem("product") === "WRAPSODY_ECO"
            ? 1
            : 10
        }
        onKeyDown={(e) =>
          ["e", "E", "+", "-", ".", "Enter"].includes(e.key) &&
          e.preventDefault()
        }
        disabled={isRenew}
        isInvalid={!!errors.licenseCount && !!touched?.licenseCount}
      />
      <Form.Control.Feedback type="invalid">
        <>{errors?.licenseCount}</>
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default LicenseCount;
